export default {
    SET_CARDS: (state, cards) => {
        state.cards = cards
    },

    SET_LOAD: (state, isLoaded) => {
        state.isLoaded = isLoaded
    },

    SET_FILTERS: (state, filters) => {
        state.filters = filters
    },

    SET_PAGINATION: (state, pagination) => {
        state.pagination = pagination
    },

    RESET_CARDS: (state) => {
        state.filters = {
            clientId: null,
            paymentId: null,
            phoneNumber: null
        }
    }
}
